export default "__VITE_ASSET__B_ySbWI5__"